import httpService from "../../Service/httpService";

const controller = "Login";

export const getPermiso = async (id, idUsr, modulo) => {
  const res = await httpService.get(
    `/${controller}/getPermiso/${id}/${idUsr}/${modulo}`,
  );
	if(res.data === ''){
		window.location = `/#/App/Home/AccesoModulo`;
	}
	return res.data;
};

